import { IconButton, Menu, MenuItem } from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import { useState } from 'react'

export const RowActionMenu = ({
  row,
  ariaLabel = 'Row actions',
  actions = [],
  iconSize = 'small',
  onOpen,
  onClose,
}) => {
  const [anchorEl, setAnchorEl] = useState(null)

  const handleOpen = (event) => {
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
    // Prevent transient focus + aria-hidden warnings when Menu toggles modal state.
    requestAnimationFrame(() => {
      event.currentTarget?.blur?.()
    })
    onOpen?.(row)
  }

  const handleClose = () => {
    setAnchorEl(null)
    onClose?.(row)
  }

  return (
    <>
      <IconButton size={iconSize} aria-label={ariaLabel} onClick={handleOpen}>
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        slotProps={{ list: { autoFocusItem: true } }}
      >
        {actions
          .filter((a) => (typeof a.visible === 'function' ? a.visible(row) : a.visible !== false))
          .map((action) => (
            <MenuItem
              key={action.id}
              onClick={() => {
                action.onClick?.(row)
                handleClose()
              }}
              disabled={typeof action.disabled === 'function' ? action.disabled(row) : !!action.disabled}
              sx={action.color === 'error' ? { color: 'error.main' } : undefined}
            >
              {action.icon ? <action.icon fontSize="small" style={{ marginRight: 8 }} /> : null}
              {action.label}
            </MenuItem>
          ))}
      </Menu>
    </>
  )
}
